import { render, staticRenderFns } from "./c-indikator.vue?vue&type=template&id=2d1be614&"
import script from "./c-indikator.vue?vue&type=script&lang=js&"
export * from "./c-indikator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports